import { Container, Navbar, Dropdown } from "react-bootstrap"
import Logo from '../../assets/images/ai-logo.png'
import avtar from '../../assets/images/avtar-male.png'
import { GoChevronDown } from "react-icons/go";
import { Link } from "react-router-dom";
import { useState } from "react";
const Header = () => {

    
    const [menuOpen, setMenuOpen] = useState(false);

    const handleMenuToggle = () => {
      document.body.classList.toggle("show-mo-menu");
      setMenuOpen((prev) => !prev);
    };
  
    const handleMenuClose = () => {
      document.body.classList.remove("show-mo-menu");
      setMenuOpen(false);
    };
    return(
        <>
            <header className="site-header">
            <Container fluid className="header-nav">
  <Navbar expand="lg" className="w-100 d-flex align-items-center">
    {/* Brand / Logo */}
    <Navbar.Brand className="me-3">
      <img src={Logo} width={80} alt="logo" />
    </Navbar.Brand>

    {/* Push everything else to the right */}
    <div className="d-flex align-items-center ms-auto gap-3">
      {/* Toggle (hamburger) positioned at right now */}
      <Navbar.Toggle
        aria-controls="basic-navbar-nav"
        onClick={handleMenuToggle}
        className="border-0 shadow-none d-flex align-items-center d-block d-sm-none"
      />

      {/* Profile Dropdown */}
      <Dropdown className="profile-dd">
        <Dropdown.Toggle className="d-flex align-items-center bg-transparent border-0 shadow-none">
          <div className="d-flex gap-2 align-items-center">
            <img
              src={avtar}
              width={35}
              height={35}
              className="rounded-circle object-fit-cover"
              alt="profile"
            />
            <div className="d-none d-sm-block">
              <p className="font-14 mb-0 text-dark fw-medium">Randy Wonana</p>
              <p className="font-12 mb-0 text-secondary">
                randywonana123@gmail.com
              </p>
            </div>
          </div>
          <GoChevronDown size={16} className="icon ms-1" />
        </Dropdown.Toggle>

        <Dropdown.Menu align="end">
        <Dropdown.Item href="/profile">Profile</Dropdown.Item>
          <Dropdown.Item href="/login">Logout</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  </Navbar>
</Container>
                </header>
        
        </>
    )
}
export default Header;


